import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce5d73f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-2xl" }
const _hoisted_2 = { class: "w-full mt-2 table-auto text-lg rounded border-2 dark:border-dark-400 dark:bg-dark-500" }
const _hoisted_3 = { class: "border border-gray-300 dark:border-dark-400 bg-gray-200 dark:bg-dark-400" }
const _hoisted_4 = { class: "border border-gray-300 dark:border-dark-400 bg-gray-200 dark:bg-dark-400" }
const _hoisted_5 = { class: "text-center select" }
const _hoisted_6 = { class: "border px-1 py-1 border-gray-300 dark:border-dark-400" }
const _hoisted_7 = { class: "border px-1 py-1 w-9/12 border-gray-300 dark:border-dark-400" }
const _hoisted_8 = { class: "dropdown w-full relative px-2" }
const _hoisted_9 = {
  class: "mr-0 notranslate",
  style: {"float":"left"}
}
const _hoisted_10 = {
  class: "fill-current h-4 w-4",
  style: {"float":"right","margin-top":"4px"},
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "w-11/12 dropdown-menu absolute hidden shadow-xl z-10" }
const _hoisted_14 = ["value"]
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = { class: "text-center select" }
const _hoisted_17 = { class: "border px-1 py-1 border-gray-300 dark:border-dark-400" }
const _hoisted_18 = { class: "border px-1 py-1 w-9/12 border-gray-300 dark:border-dark-400" }
const _hoisted_19 = { class: "dropdown w-full relative px-2" }
const _hoisted_20 = {
  class: "mr-0 notranslate",
  style: {"float":"left"}
}
const _hoisted_21 = {
  class: "fill-current h-4 w-4",
  style: {"float":"right","margin-top":"4px"},
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "w-11/12 dropdown-menu absolute hidden shadow-xl z-10" }
const _hoisted_25 = ["value"]
const _hoisted_26 = ["disabled", "onClick"]
const _hoisted_27 = { class: "text-2xl mt-10" }
const _hoisted_28 = { class: "my-2 toggle-switch" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "toggle-label",
  for: "toggle"
}, null, -1))
const _hoisted_30 = { class: "text-2xl mt-10" }
const _hoisted_31 = { class: "my-2 flex items-start justify-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_PrimaryModal = _resolveComponent("PrimaryModal")!

  return (_openBlock(), _createBlock(_component_PrimaryModal, {
    onClickBackground: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modalStatePresenter.setIsShowSettingsModal(false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["problem-select-wrapper max-w-screen-lg box-border px-12 py-8 m-4 overflow-y-scroll", {
        'custom-scrollbar': _ctx.isLightMode(),
        'custom-scrollbar-dark': !_ctx.isLightMode()
      }]),
        style: {"user-select":"none"}
      }, [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('message.shortcutKey')), 1),
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('message.command')), 1),
              _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('message.keyBind')), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", _hoisted_5, [
              _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.$t('message.run')), 1),
              _createElementVNode("td", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "border pt-1 pl-2 pr-1 mt-1 items-center rounded focus:outline-none text-lg w-full border-gray-500 dark:bg-dark-200 dark:border-dark-200 dark:text-dark-text",
                    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nested.hide.value = false))
                  }, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.nested.input[0].value), 1),
                    (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
                  ], 32),
                  _withDirectives(_createElementVNode("ul", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        value: item
                      }, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["w-full py-1 px-2 min-w-full block whitespace-no-wrap text-left focus:outline-none text-lg border-r border-l", {
                        'list-round-first border-t': index == 0,
                        'list-round-last border-b': index == _ctx.items.length - 1,
                        'bg-dark-200 text-dark-text hover:bg-dark-10': _ctx.shortcutKey[1].value != item && !_ctx.isLightMode(),
                        'bg-white text-gray-800 hover:bg-gray-400': _ctx.isLightMode(),
                        'border-dark-200': !_ctx.isLightMode(),
                        'bg-gray-400 hover:bg-gray-400 text-gray-800': _ctx.shortcutKey[1].value == item && _ctx.isLightMode(),
                        'bg-dark-10 text-dark-text': _ctx.shortcutKey[1].value == item && !_ctx.isLightMode()
                      }]),
                          disabled: _ctx.shortcutKey[1].value == item,
                          onClick: ($event: any) => (_ctx.onSelect(item, index, 0))
                        }, _toDisplayString(item), 11, _hoisted_15)
                      ], 8, _hoisted_14))
                    }), 128))
                  ], 512), [
                    [_vShow, !_ctx.nested.hide.value]
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", _hoisted_16, [
              _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.$t('message.submit')), 1),
              _createElementVNode("td", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    class: "border pt-1 pl-2 pr-1 mt-1 items-center rounded focus:outline-none text-lg w-full border-gray-500 dark:bg-dark-200 dark:border-dark-200 dark:text-dark-text",
                    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nested.hide.value = false))
                  }, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.nested.input[1].value), 1),
                    (_openBlock(), _createElementBlock("svg", _hoisted_21, _hoisted_23))
                  ], 32),
                  _withDirectives(_createElementVNode("ul", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: "w-full",
                        value: item
                      }, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["w-full py-1 px-2 min-w-full block whitespace-no-wrap text-left focus:outline-none text-lg border-r border-l", {
                        'list-round-first border-t': index == 0,
                        'list-round-last border-b': index == _ctx.items.length - 1,
                        'bg-dark-200 text-dark-text hover:bg-dark-10': _ctx.shortcutKey[0].value != item && !_ctx.isLightMode(),
                        'bg-white text-gray-800 hover:bg-gray-400': _ctx.isLightMode(),
                        'border-dark-200': !_ctx.isLightMode(),
                        'bg-gray-400 hover:bg-gray-400 text-gray-800': _ctx.shortcutKey[0].value == item && _ctx.isLightMode(),
                        'bg-dark-10 text-dark-text': _ctx.shortcutKey[0].value == item && !_ctx.isLightMode()
                      }]),
                          disabled: _ctx.shortcutKey[0].value == item,
                          onClick: ($event: any) => (_ctx.onSelect(item, index, 1))
                        }, _toDisplayString(item), 11, _hoisted_26)
                      ], 8, _hoisted_25))
                    }), 128))
                  ], 512), [
                    [_vShow, !_ctx.nested.hide.value]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("h1", _hoisted_27, _toDisplayString(_ctx.$t('message.darkmode')), 1),
        _createElementVNode("div", _hoisted_28, [
          _withDirectives(_createElementVNode("input", {
            id: "toggle",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isDarkMode) = $event)),
            class: "toggle-input",
            type: "checkbox",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkDarkMode()))
          }, null, 544), [
            [_vModelCheckbox, _ctx.isDarkMode]
          ]),
          _hoisted_29
        ]),
        _createElementVNode("h1", _hoisted_30, _toDisplayString(_ctx.$t('message.displayLanguage')), 1),
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_DropDown, {
            itemList: _ctx.displayLanguages,
            selected: _ctx.selectDisplayLanguage,
            selectedIndex: _ctx.nested.selectedDisplayLanguageIndex.value
          }, null, 8, ["itemList", "selected", "selectedIndex"])
        ])
      ], 2)
    ]),
    _: 1
  }))
}